module.exports = "/_next/static/images/img_list-2-9fed01abf544c250bf7bb2f1846faa57.png";